import { NavigateRoutes } from 'common/constants/app.constant';
import { BaseDataModel, FormMetaModel, BHMetaInputModel, BHMetaSelectModel, BHBtnMetaModel, BHMetaCalenderModel } from 'common/models/utilitymodels/base.model';

export class OTMModel extends BaseDataModel {
    bankName: string = '';
    accountHolderName: string = '';
    amount: string = '';
    startDate: string = '';
    endDate: string = '';
    errorModel: any[] = [];
}

export class OTMPostParams {
    BANK_NAME: string = 'Axis Bank';
    BRANCH_NAME: string = 'Alandur';
    AC_TYPE: string = 'SB';
    AC_NO: string = '';
    BANK_ADDRESS1: string = '';
    BANK_ADDRESS2: string = '';
    BANK_ADDRESS3: string = '';
    BANK_CITY: string = '';
    BANK_STATE: string = '';
    BANK_COUNTRY: string = '';
    BANK_PINCODE: string = '';
    IFSC_CODE: string = '';
    MICR_CODE: string = '';
    ACCOUNT_HOLDER_NAME: string = 'Thiyanithi M';
    FROM_DATE: string = '07-Jul-2023';
    TO_DATE: string = '07-Jul-2099';
    AMOUNT: string = '100';
    FOLIO_NO: string = '186456';
    USER_TYPE: string = '';
    TRXN_DETAILS: string = '';
    TRXN_PAGE: string = '';
    FREQUENCY: string = 'ADHO';
    STATUS: string = '';
    DIS_USERNAME: string = '';
    DIS_MOBILE: string = '';
    DIS_EMAIL: string = '';
    PRIMARYHOLDER_USERNAME: string = '';
    PRIMARYHOLDER_MOBILE: string = '';
    PRIMARYHOLDER_EMAIL: string = '';
    PRIMARYHOLDER_PAN: string = '';
    TRANSACTION_REF_NO: string = '';
    TRG_USER_NAME: string = '';
    BROK_DLR_CODE: string = '';
    OTM_BANK_CODE: string = '';
}

export class OTMMetaModel extends FormMetaModel {
    accountHolderName = new BHMetaInputModel('accountHolderName', 'accountHolderName', true, 'Name As Per Bank Records', 'text', 'Enter the name', 50, 0, false);
    bankName = new BHMetaSelectModel('bankName', 'bankName', true, 'Select Bank', 'select', 'Select Bank', [], 'BANK_NAME', 'BANK_NAME', false);
    startDate = new BHMetaCalenderModel('startDate', 'startDate', true, 'Start Date', '', false, [], this.getDateObject(new Date()));
    endDate = new BHMetaCalenderModel('endDate', 'endDate', true, 'End Date', '', true, [], this.getDateObject(new Date()), '', 'End Date');
    amount = new BHMetaInputModel('amount', 'amount', true, 'Amount', 'number', 'Enter Amount', 50, 0, false);
    transferDetailsList: 'Amount' | 'Units' = 'Amount';
    saveButton = new BHBtnMetaModel('dark', 'SAVE');
    cancelButton = new BHBtnMetaModel('light', 'CANCEL');
    submitButton = new BHBtnMetaModel('dark', 'SUBMIT');
    amountList: { value: string; selected: boolean }[] = [
        { value: '5000', selected: false },
        { value: '10000', selected: false },
        { value: '25000', selected: false },
        { value: '50000', selected: false },
        { value: '100000', selected: false },
    ];
    brokerFormOpen: boolean = false;
    brokerInfo: any = null;
    minValue: number;
    maxValue: number;
    minUnits: number;
    maxUnits: number;
    otmMinAmount: number = 100;
    otmMaxAmount: number = 1000000;
    amountCustomError: string = '';
    unitCustomError: string = '';
    selectedBank: any = null;
    selectedAccountType: string = '';
    showAccDetailCard: boolean = false;
    otmValidBnakList: any = null;

    constructor() {
        super('E-OTM Transaction', NavigateRoutes.distributordashboard, true, NavigateRoutes.selectInvestor);
    }

    initProperties() {
        return {
            bankName: this.bankName,
            accountHolderName: this.accountHolderName,
            amount: this.amount,
            startDate: this.startDate,
            endDate: this.endDate,
            amountList: this.amountList,
            saveButton: this.saveButton,
            cancelButton: this.cancelButton,
            submitButton: this.submitButton,
            minValue: this.minValue,
            maxValue: this.maxValue,
            amountCustomError: this.amountCustomError,
            minUnits: this.minUnits,
            maxUnits: this.maxUnits,
            otmMinAmount: this.otmMinAmount,
            otmMaxAmount: this.otmMaxAmount,
            unitCustomError: this.unitCustomError,
            selectedAccountType: this.selectedAccountType,
            otmValidBnakList: this.otmValidBnakList,
        };
    }

    getDateObject(date: Date): { year: number; month: number; day: number } {
        const year = date.getFullYear();
        const month = date.getMonth() + 1; // Note: January is 0, so we add 1
        const day = date.getDate();

        return { year, month, day };
    }
}
